/**
 * Portal Manta · Dados
 * Extraído de portal_manta_v28_12.jsx
 * v29 modular · 2026-05-11
 */

export const ESTUDOS_INIT=[
  {id:'est-01',nome:'Estudo 01',concessao:'L4 · Revisão completa',criado:'2026-04-18',etapa:2,docTipo:'Edital ANTT'},
  {id:'est-02',nome:'Estudo 02',concessao:'Lote MG novo',         criado:'2026-04-21',etapa:1,docTipo:'—'},
];
